import { render } from "./MetadataCard.vue?vue&type=template&id=cfb26186&scoped=true"
import script from "./MetadataCard.vue?vue&type=script&lang=js"
export * from "./MetadataCard.vue?vue&type=script&lang=js"

import "./MetadataCard.vue?vue&type=style&index=0&id=cfb26186&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb26186"]])

export default __exports__